import { Injectable } from '@angular/core';

import { CompanyEnum } from '../definitions/company.enum';
import {
  educaConf,
  educaopenaiConf,
  edusportConf,
  enaldeConf,
  esibeConf,
  euroinnovaConf,
  ineafConf,
  inesaludConf,
  inesemConf,
  innovaConf,
  rededucaConf,
  universityConf
} from '../environments/customer.conf';
import { CustomerConfInterface } from '../interfaces/customerConf.interface';

@Injectable({
  providedIn: 'root'
})
export class SubdomainConfigService {
  public getConfigForSubdomain(subdomain: string): CustomerConfInterface {
    switch (subdomain) {
      case CompanyEnum.INESALUD:
        return inesaludConf;
      case CompanyEnum.INESEM:
        return inesemConf;
      case CompanyEnum.EDUCA:
        return educaConf;
      case CompanyEnum.EDUSPORT:
        return edusportConf;
      case CompanyEnum.ENALDE:
        return enaldeConf;
      case CompanyEnum.ESIBE:
        return esibeConf;
      case CompanyEnum.INEAF:
        return ineafConf;
      case CompanyEnum.INNOVA:
        return innovaConf;
      case CompanyEnum.REDEDUCA:
        return rededucaConf;
      case CompanyEnum.EDUCAOPENAI:
        return educaopenaiConf;
      case CompanyEnum.MARKETPLACE:
        return universityConf;
      default:
        return euroinnovaConf;
    }
  }
}
